var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "149px",
    height: "149px",
    viewBox: "-1.92 -1.92 67.84 67.84",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    stroke: "#fff",
    strokeWidth: 1.92,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.512
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,2c0,1.104,0.896,2,2,2c7.479,0,14.51,2.913,19.798,8.202C57.087,17.49,60,24.521,60,32c0,7.381-2.842,14.323-8,19.587 V46c0-1.104-0.896-2-2-2s-2,0.896-2,2v12h12c1.104,0,2-0.896,2-2s-0.896-2-2-2h-4.776C60.885,48.032,64,40.257,64,32 c0-8.547-3.329-16.583-9.374-22.627C48.583,3.329,40.547,0,32,0C30.896,0,30,0.896,30,2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.374,54.627C15.417,60.671,23.453,64,32,64c1.104,0,2-0.896,2-2s-0.896-2-2-2c-7.479,0-14.51-2.913-19.798-8.202 C6.913,46.51,4,39.479,4,32c0-7.381,2.842-14.323,8-19.587V18c0,1.104,0.896,2,2,2s2-0.896,2-2V6H4C2.896,6,2,6.896,2,8 s0.896,2,2,2h4.776C3.115,15.968,0,23.743,0,32C0,40.547,3.329,48.583,9.374,54.627z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/reverse.a0883a2fe2556d810161cc3e058fb61f.svg";
export { ForwardRef as ReactComponent };